import React from 'react';
import Aux from '../../../Hoc/Aux/Aux';

const Course = (props) =>  {
    const courseText = props.content;
    let listItems = courseText.map((textItem, index) =>
        <li key={index}>{textItem}</li>
    );

    return (
        <Aux>
            <article>
                <span className="icon" style={{height: '70px', width: '70px'}}>
                    <figure>
                        <img src={props.icon} style={{height: '70px', width: '70px'}} alt="Icon"/>
                    </figure>
                </span>
                    <div className="content">
                        <h1>{props.title.toUpperCase()}</h1>
                        <ul>
                            {listItems}
                        </ul>
                    </div>
            </article>
        </Aux>
    )
};

export default Course;


// WEBPACK FOOTER //
// ./src/Components/Courses/Course/Course.js